module.exports = __webpack_public_path__ + "assets/images/rbyearend-12-desktop.jpg?v=4f2533c9";